module.exports = __webpack_public_path__ + "assets/13d03d9a4bf42944fb60aa09f9c3921d.mp3";